module.exports = __webpack_public_path__ + "img/casa.2ec5d66f.png";